import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 21.6a.9.9 0 0 1-.9-.9V5.592l-2.34 2.52a.9.9 0 0 1-1.32-1.224l3.9-4.2a.9.9 0 0 1 1.32 0l3.9 4.2a.9.9 0 0 1-1.32 1.224l-2.34-2.52V20.7a.9.9 0 0 1-.9.9",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }